import * as React from 'react'

function SvgUsefulLinksTwoTone(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 57 57" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.633 20.343L12.65 32.325a8.525 8.525 0 1012.056 12.056 2 2 0 112.828 2.829c-4.89 4.891-12.821 4.891-17.713 0-4.89-4.891-4.89-12.822 0-17.713l11.985-11.984a3.997 3.997 0 015.654.002l4.54 4.54a2 2 0 01-2.829 2.828l-4.54-4.54zm-.003-.002l.002.001h.001-.003z"
        fill="#1B2736"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.504 36.544l11.979-11.979A8.523 8.523 0 0032.43 12.512a2 2 0 11-2.828-2.828c4.89-4.89 12.819-4.89 17.71 0 4.89 4.89 4.89 12.82 0 17.71L35.33 39.374a3.997 3.997 0 01-5.654-.001l-4.539-4.539a2 2 0 112.829-2.828l4.538 4.538zm.002.003l-.001-.001h-.001.002z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgUsefulLinksTwoTone
